
import { mapState } from "vuex";

const WIDGET = "CLEAR_REFINEMENT";

export default {
  computed: {
    ...mapState("productsSearch", ["currentPageResults"]),
    hasRefinements() {
      return this.currentPageResults?.filterSummary?.length > 0 ?? false;
    },
    filterURL() {
      return `${this.$route.path}?${this.$productsSearch.createURL(WIDGET)}`;
    },
  },

  methods: {
    refine() {
      try {
        this.$store.dispatch("productsSearch/refine", { widget: WIDGET });
        this.$nuxt.$emit("clear-all");
      } catch (error) {
        this.$bugsnag.notify(error);
      }
    },
  },
};
